import React, { useState, useCallback } from 'react';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { individual_header_style } from '../../../../../../../../../../assets/styles/table_custom_style';
import BootstrapTable from 'react-bootstrap-table-next';
import { Table } from 'reactstrap';
import ReactButton from 'components/Buttons/ReactButton';
import ConfirmationModal from 'components/Modal/ConfirmationModal';
import { toast } from 'react-toastify';
import { parseISO, format } from 'date-fns';
import ChatBroadcastListService from '../../../../../../../../../ChatBroadcastList/service';
import ChatBroadcastListSMSService from '../../../../../../../../../ChatBroadcastListSMS/service';
import DialerService from '../../../../../../../../../Dialer/service';

const ListMultiCampaignsTable = ({
  onModalToggle,
  chatBroadcastList,
  handleOnSelect,
  selectedRows,
  handleOnSelectAll,
  initMultiCampaignModal,
  contacts,
  campaignType
}) => {
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const closeModal = useCallback(() => onModalToggle(false), [onModalToggle]);

  const createDynamicColumns = () => {
    const columns = [];

    columns.push({
      dataField: campaignType === 'discador' ? 'name' : 'title',
      text: 'Nome',
      sort: true,
      style: {
        paddingTop: '25px',
        paddingBottom: '25px'
      },
      headerStyle: { ...individual_header_style, cursor: 'pointer' }
    });

    return [...columns];
  };

  const dynamicFunctionColumns = createDynamicColumns();

  const handleSelectCampaignSend = (campaign) => {
    setSelectedCampaign(campaign);
    setOpenModalConfirmation(true);
  };

  const handleConfirmExport = async () => {
    if (!selectedCampaign || !contacts.length) return;

    try {
      if (campaignType === 'whatsapp') {
        const clients = contacts.map((contact) => ({
          id: contact.id,
          name: contact.name
        }));
        await ChatBroadcastListService.addContactsToBroadcastList(
          selectedCampaign.id,
          clients
        );
      } else if (campaignType === 'sms') {
        const clients = contacts.map((contact) => ({
          id: contact.id,
          name: contact.name
        }));
        await ChatBroadcastListSMSService.addContactsToBroadcastList(
          selectedCampaign.id,
          clients
        );
      } else if (campaignType === 'discador') {
        const headers = ['identificador', 'nome', 'whatsappNumber', 'numero'];
        const formattedContacts = [
          headers,
          ...contacts.map((contact) => [
            contact.phone?.toString() || '',
            contact.name || '',
            contact.id_whatsapp || '',
            contact.phone || ''
          ])
        ];

        const visualizationData = Array(formattedContacts.length).fill([]);

        const payload = {
          parsedCsv: formattedContacts,
          dialer_id: selectedCampaign.id,
          queue_id: selectedCampaign.queue_id,
          parsedVizualizationCsv: visualizationData,
          replaceExistingContacts: false
        };

        const response = await DialerService.createMalling(payload);

        const hadAccepteds = response.data.data.accepted.length;
        const hadRejections = response.data.data.rejected.length;

        toast.warn(
          `${hadAccepteds} contatos foram importados com sucesso e ${hadRejections} contatos não puderam ser importados`,
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
        setOpenModalConfirmation(false);
        closeModal();
        return;
      } else {
        console.warn('Tipo de campanha não suportado:', campaignType);
        return;
      }

      toast.success('Contato(s) exportado(s) com sucesso');
      setOpenModalConfirmation(false);
      closeModal();
    } catch (error) {
      console.error('Erro completo:', error);
    }
  };

  return (
    <>
      {initMultiCampaignModal ? (
        <ToolkitProvider
          data={(chatBroadcastList || []).filter(
            (campaign) =>
              campaignType !== 'discador' || campaign.pid_process === null
          )}
          keyField="id"
          columns={dynamicFunctionColumns}
        >
          {(props) => (
            <div className="py-4 table-responsive">
              <BootstrapTable
                selectRow={{
                  mode: 'checkbox',
                  selected: selectedRows.map((r) => r.id),
                  onSelect: handleOnSelect,
                  onSelectAll: handleOnSelectAll
                }}
                bootstrap4={true}
                bordered={false}
                classes="align-items-center"
                {...props.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
      ) : (
        <Table md="10" hover={true}>
          <thead>
            <tr>
              <th>Lista de transmissão</th>
              <th>Data de criação</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {(chatBroadcastList || [])
              .filter(
                (campaign) =>
                  campaignType !== 'discador' || campaign.pid_process === null
              )
              .map((campaign) => {
                const dateCreated = campaign.created_at
                  ? format(parseISO(campaign.created_at), 'dd/MM/yyyy')
                  : '';

                const campaignName =
                  campaignType === 'discador' ? campaign.name : campaign.title;

                return (
                  <tr key={campaign.id} style={{ cursor: 'pointer' }}>
                    <td>{campaignName}</td>
                    <td>{dateCreated}</td>
                    <td>
                      <ReactButton
                        btnColor="primary"
                        onClick={() => handleSelectCampaignSend(campaign)}
                      >
                        Selecionar
                      </ReactButton>
                    </td>
                  </tr>
                );
              })}
            {(!chatBroadcastList ||
              !chatBroadcastList.filter(
                (campaign) =>
                  campaignType !== 'discador' || campaign.pid_process === null
              ).length) && (
              <tr>
                <td colSpan="3">
                  <p>Nenhuma campanha registrada</p>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}

      <ConfirmationModal
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={selectedCampaign?.id}
        deleteResource={handleConfirmExport}
        message={`Tem certeza que deseja exportar para ${
          campaignType === 'discador' ? 'a campanha' : 'a lista de transmissão'
        }: "${
          campaignType === 'discador'
            ? selectedCampaign?.name
            : selectedCampaign?.title
        }"?`}
      />
    </>
  );
};

export default ListMultiCampaignsTable;
